import _axios, { AxiosRequestConfig } from "axios";
import Cookies from "universal-cookie";

const baseURL = process.env["REACT_APP_API_URL"];
const instance = _axios.create({
  baseURL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (request) => {
    const cookies = new Cookies();
    const jwt = cookies.get("book-d booking token");

    if (request.headers && !request.headers["x-access-token"]) {
      request.headers["x-access-token"] = jwt;
    }
    return request;
  },
  (error) => Promise.reject(error)
);

const handleApiSuccess = (res: any) => {
  return res;
};

const handleApiError = (err: any) => {
  let errorMessage = "";
  // request was manually cancelled in a `useEffect` hook
  if (_axios.isCancel(err)) {
    return; // fail silently
  }

  if (err.response) {
    const apiError = err.response.data;
    // client received an error response (5xx, 4xx)
    console.error(
      `Server returned code ${err.response.status}` +
        `body was: ${apiError.error}`,
      "data:",
      apiError
    );
    errorMessage = apiError.error || "Something went wrong";
  } else if (err.request) {
    // client never received a response, or request never left
    console.error("An error occurred:", err.message);
  } else {
    // anything else
    console.error("Well, that was unexpected");
  }

  return errorMessage;
};

export const Api = {
  get: (endpoint: string, config: AxiosRequestConfig<any> | undefined) =>
    instance.get(endpoint, config).then(handleApiSuccess).catch(handleApiError),

  post: (
    endpoint: string,
    data: any,
    config: AxiosRequestConfig<any> | undefined
  ) =>
    instance
      .post(endpoint, data, config)
      .then(handleApiSuccess)
      .catch(handleApiError),

  put: (
    endpoint: string,
    data: any,
    config: AxiosRequestConfig<any> | undefined
  ) =>
    instance
      .put(endpoint, data, config)
      .then(handleApiSuccess)
      .catch(handleApiError),

  patch: (
    endpoint: string,
    data: any,
    config: AxiosRequestConfig<any> | undefined
  ) =>
    instance
      .patch(endpoint, data, config)
      .then(handleApiSuccess)
      .catch(handleApiError),

  delete: (endpoint: string, config: AxiosRequestConfig<any> | undefined) =>
    instance
      .delete(endpoint, config)
      .then(handleApiSuccess)
      .catch(handleApiError),
};
